import get from 'lodash/get';
import * as fetchActions from 'actions/CartActions/FetchCartDetailsActions';
import * as updateActions from 'actions/CartActions/UpdateCartActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';
const { GET_BASKET_DETAILS } = fetchActions;
const { REMOVE_FROM_BASKET, CHANGE_QUANTITY_IN_BASKET, UNDO_DELETE_FROM_BASKET } = updateActions;
import { MODAL_PAGE_DATA_ACTIONS } from 'actions/pageActionsV4';
const defaultState = {
    asyncStatus: AsyncStatus.INIT,
    pageLevelError: false
};
export default function cartData(state = defaultState, action) {
    switch (action && action.type) {
        case GET_BASKET_DETAILS.REQUEST:
        case REMOVE_FROM_BASKET.REQUEST:
        case CHANGE_QUANTITY_IN_BASKET.REQUEST:
        case UNDO_DELETE_FROM_BASKET.REQUEST:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.LOADING,
                pageLevelError: false
            });
        case GET_BASKET_DETAILS.SUCCESS:
        case REMOVE_FROM_BASKET.SUCCESS:
        case CHANGE_QUANTITY_IN_BASKET.SUCCESS:
        case UNDO_DELETE_FROM_BASKET.SUCCESS:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.SUCCESS,
                data: get(action, ['data', 'cartDetails']),
                timeStamp: new Date().getTime()
            });
        case MODAL_PAGE_DATA_ACTIONS.SUCCESS:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.SUCCESS,
                data: get(action, ['data']),
                timeStamp: new Date().getTime()
            });
        case GET_BASKET_DETAILS.ERROR:
        case REMOVE_FROM_BASKET.ERROR:
        case CHANGE_QUANTITY_IN_BASKET.ERROR:
        case UNDO_DELETE_FROM_BASKET.ERROR:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.ERROR,
                error: action.error,
                pageLevelError: action.type === GET_BASKET_DETAILS.ERROR
            });
        default:
            return state;
    }
}
